<!-- @format -->

@if (formGroup) {
  <div class="row">
    <div class="col-12">
      <ng-content></ng-content>
      @if (label) {
        <label [class]="labelState">{{ label }}</label>
      }
      <sis-language-pills
        [attr.data-cy]="'localized-string-editor-lang'"
        [invalidLocales]="getInvalidLangFields()"
        [(selectedLanguage)]="currentLocale"
        (selectedLanguageChange)="focusLocaleInput($event)"></sis-language-pills>
      @if (guidance) {
        <p class="guidance">{{ guidance | translate }}</p>
      }
      <div class="tab-content">
        @for (locale of locales; track locale) {
          <div>
            @if (!useTextArea) {
              <input
                [name]="locale"
                [formControl]="getControlFor(locale)"
                [attr.id]="getInputFieldId(locale)"
                [class.active]="currentLocale === locale"
                [class.invalid]="formGroup.touched && isInvalid(locale)"
                (focus)="currentLocale = locale"
                autocomplete="off"
                class="form-control string-input"
                placeholder="{{ placeholder | translate }}"
                [readonly]="getControlFor(locale)?.disabled"
                tabindex="0"
                type="text"
                #input />
            }
            @if (useTextArea) {
              <textarea
                [name]="locale"
                [formControl]="getControlFor(locale)"
                [attr.id]="getInputFieldId(locale)"
                [class.active]="currentLocale === locale"
                [class.invalid]="formGroup.touched && isInvalid(locale)"
                (focus)="currentLocale = locale"
                autocomplete="off"
                class="form-control string-input"
                placeholder="{{ placeholder | translate }}"
                [readonly]="getControlFor(locale)?.disabled"
                tabindex="0"
                type="text"
                #input>
              </textarea>
            }
          </div>
        }
      </div>
    </div>
  </div>
  @if (isValidationErrorBlockVisible()) {
    <sis-validation-errors [asFormGroup]="true" [control]="formGroup">
      @if (getLocalesWithError("minLength").length > 0) {
        <p class="error-list__item">
          {{
            "SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.TOO_SHORT"
              | translate: { langnames: getLocalesWithError("minLength") | localeNames | async | localizedStringArray }
          }}
        </p>
      }
      @if (getLocalesWithError("maxLength").length > 0) {
        <p class="error-list__item">
          {{
            "SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.TOO_LONG"
              | translate: { langnames: getLocalesWithError("maxLength") | localeNames | async | localizedStringArray }
          }}
        </p>
      }
      @if (getLocalesWithError("required").length > 0) {
        <p class="error-list__item">
          {{ "SIS_COMPONENTS.STRING.LOCALIZED_STRING_EDITOR.ALL_REQUIRED" | translate }}
        </p>
      }
    </sis-validation-errors>
  }
  @if (helpBlock) {
    <p [id]="name + '_help-block'" class="help-block">{{ helpBlock | translate: helpBlockParams }}</p>
  }
}
